import React from 'react';
import { Notification } from 'commons/components';
import { NotificationTypes } from 'commons/services';

function HomeCards(): JSX.Element {
  return (
    <Notification
      listeningToTypes={[
        NotificationTypes.NoType,
        NotificationTypes.PolRemediationPending,
        NotificationTypes.PolRemediationPendingModal,
        NotificationTypes.WithdrawsTemporarilyBlocked,
        NotificationTypes.WithdrawalCanceled,
        NotificationTypes.D1Enabled,
        NotificationTypes.KycIdentityValidated,
      ]}
      tagOnLoad={[
        [
          NotificationTypes.KycIdentityValidated,
          'pago-nube-identidad-validada-view',
        ],
      ]}
    />
  );
}

export default HomeCards;
